import { reportsApi } from 'Api/axios/reports-api';
import { useEffect, useState } from 'react';
import { CourseReportFilterI, CourseReportI } from 'types';

interface Props {
  init?: boolean;
}

const useCoursesReportApi = ({ init = false }: Props) => {
  const [data, setData] = useState<CourseReportI[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCoursesReport = async (filters: CourseReportFilterI) => {
    setLoading(true);
    const response = await reportsApi.readCourses(filters);
    setLoading(false);
    setData(response.data ?? []);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchCoursesReport({});
    }
  }, [init]);

  return {
    data,
    loading,
    error,
    fetchCoursesReport,
  };
};

export default useCoursesReportApi;
